import HttpService from "./http.service";

class ReceivablesService {
  list = async (sortStr = null, filterStr = null) => {
    const receivablesEndpoint = `/receivables?limit=-1${
      sortStr ? sortStr : ""
    }${filterStr ? filterStr : ""}`;
    return await HttpService.get(receivablesEndpoint);
  };

  paginate = async (page = 0, limit = 25, sortStr = null, filterStr = null) => {
    const receivablesEndpoint = `/receivables?page=${page}&limit=${limit}${
      sortStr ? sortStr : ""
    }${filterStr ? filterStr : ""}`;
    return await HttpService.get(receivablesEndpoint);
  };

  // Parcelas, conta original e valor em aberto (para parcelar).
  parcelamento = async (id) => {
    return await HttpService.get(`/receivables/${id}/parcelamento`);
  };

  // data: { parcelas: [{ valor, dataVencimento }] }
  parcelar = async (id, data) => {
    return await HttpService.post(`/receivables/${id}/parcelar`, data);
  };

  get = async (id) => {
    const receivablesEndpoint = "/receivables";
    return await HttpService.get(`${receivablesEndpoint}/${id}`);
  };

  getPdf = async (id) => {
    const receivablesEndpoint = "/receivables";
    return await HttpService.getFile(`${receivablesEndpoint}/${id}/pdf`);
  };

  getlastMonths = async () => {
    const receivablesEndpoint = "/receivables/last-months";
    return await HttpService.get(receivablesEndpoint);
  };

  filter = async (data) => {
    const dataWithoutUndefined = Object.keys(data).reduce((object, key) => {
      if (data[key] !== undefined && data[key] !== "" && data[key] !== null) {
        object[key] = data[key];
      }
      return object;
    }, {});
    const query = new URLSearchParams(dataWithoutUndefined).toString();
    const receivablesEndpoint = `/receivables/filter?${query}`;
    return await HttpService.get(receivablesEndpoint, data);
  };

  agreementWithCustomers = async (data) => {
    const dataWithoutUndefined = Object.keys(data).reduce((object, key) => {
      if (data[key] !== undefined && data[key] !== "" && data[key] !== null) {
        object[key] = data[key];
      }
      return object;
    }, {});
    const query = new URLSearchParams(dataWithoutUndefined).toString();
    const receivablesEndpoint = `/receivables/agreement-customers?${query}`;
    return await HttpService.get(receivablesEndpoint, data);
  };

  create = async (data) => {
    const receivablesEndpoint = "/receivables";
    return await HttpService.post(receivablesEndpoint, data);
  };

  update = async (id, data) => {
    const receivablesEndpoint = "/receivables";
    return await HttpService.put(`${receivablesEndpoint}/${id}`, data);
  };

  delete = async (id) => {
    const receivablesEndpoint = "/receivables";
    return await HttpService.delete(`${receivablesEndpoint}/${id}`);
  };
}

export default new ReceivablesService();
